const RichTextModule = `
  fragment RichTextModule on RichTextModule {
    body
  }
`
export default RichTextModule
